"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
function reducer(prevState, action) {
  const {
    currentStep
  } = prevState;
  switch (action.type) {
    case 'setTermsAndConditions':
      {
        const {
          termsAndConditionsAccepted
        } = action;
        return {
          ...prevState,
          termsAndConditionsAccepted
        };
      }
    case 'stepBack':
      {
        return {
          ...prevState,
          currentStep: currentStep - 1
        };
      }
    case 'goToSummary':
      {
        return {
          ...prevState,
          currentStep: currentStep + 1
        };
      }
    case 'setCurrentStep':
      {
        return {
          ...prevState,
          currentStep: action.step
        };
      }
    case 'setFrequency':
      {
        return {
          ...prevState,
          selectedFrequency: action.item
        };
      }
    case 'setPackage':
      {
        return {
          ...prevState,
          selectedPackage: action.packageItem,
          currentStep: currentStep + 1
        };
      }
    default:
      return prevState;
  }
}
